import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormControl, FormField } from '@/components/ui/form';
import { Switch } from '@/components/ui/switch';
import { cn } from '@/lib/utils';
import { Autocomplete } from '@/modules/common';

import { eventAiOptions } from '../../../constants';

export const AIConfigurationTab = () => {
  const { control } = useFormContext();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      <Autocomplete
        name="aiModel"
        label="AI Model"
        control={control}
        placeholder="Select Ai model"
        options={eventAiOptions}
        requiredMark
      />
      <div className="gap-3 flex flex-col" key={'gptEnabled'}>
        <h3 className="text-sm font-semibold text-zinc-50">ChatGPT</h3>
        <FormField
          control={control}
          name={'gptEnabled'}
          render={({ field }) => (
            <FormControl>
              <div className="border p-2 h-[44px] border-zinc-800 rounded-md">
                <label
                  htmlFor={'gptEnabled'}
                  className="cursor-pointer flex items-center gap-2 text-zinc-100"
                >
                  <span
                    className={cn(
                      'text-sm mr-auto',
                      field.value ? 'text-zinc-50' : 'text-zinc-400'
                    )}
                  >
                    {field.value ? 'Enable' : 'Disable'}
                  </span>
                  <Switch
                    id={'gptEnabled'}
                    checked={field.value}
                    onCheckedChange={field.onChange}
                  />
                </label>
              </div>
            </FormControl>
          )}
        />
      </div>
    </div>
  );
};
